import { Export } from '@/components/Export/Export';

export default function ExportPage() {
  return <Export />;
}
